import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Checkbox, FormControlLabel, FormGroup, Grid } from "@mui/material";

const ConfirmationDialog = (props) => {
  const {
    title,
    content,
    open,
    onClose,
    onAccept,
    doNotAskAgain,
    onDoNotAskAgainPreferenceChanged,
  } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={() => onClose()}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <Grid container spacing={1} sx={{ margin: "1em" }}>
          <Grid item xs={6}>
            <FormGroup sx={{ float: "left" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={doNotAskAgain}
                    onChange={(evt, value) =>
                      onDoNotAskAgainPreferenceChanged(value)
                    }
                  />
                }
                label="Do not ask me again"
              />
            </FormGroup>
          </Grid>
          <Grid item xs={6}>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button onClick={onClose} autoFocus variant={"outlined"}>
                No
              </Button>
              <Button onClick={onAccept} autoFocus variant={"contained"}>
                Yes
              </Button>
            </DialogActions>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default ConfirmationDialog;
